"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const notistack_1 = require("notistack");
const material_ui_confirm_1 = require("material-ui-confirm");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const CompletePreviewButtons_1 = require("@/room/room_create/second_step/CompletePreviewButtons");
const wrapper_component_1 = require("@/room/room_create/wrapper_component");
function default_1({ isEdit }) {
    const roomData = (0, react_redux_1.useSelector)((state) => state.roomData);
    const { id: roomId, img_url: mainPhoto, title: roomTitle, contents: commissionContents, } = roomData;
    const { is_question, questions } = roomData;
    const delete_questions = (0, react_redux_1.useSelector)((state) => state.delete_questions);
    const { t } = (0, react_i18next_1.useTranslation)();
    const generateErrors = () => {
        let errors = [];
        const mainPhotoError = (0, CompletePreviewButtons_1.validateRoomMainPhoto)(mainPhoto);
        if (mainPhotoError)
            errors.unshift(mainPhotoError);
        const titleError = (0, CompletePreviewButtons_1.validateRoomTitle)({ roomTitle, isCommission: true });
        if (titleError)
            errors.unshift(titleError);
        const commissionContentsError = (0, CompletePreviewButtons_1.validateCommissionContents)(commissionContents);
        if (commissionContentsError)
            errors.unshift(commissionContentsError);
        const questionError = (0, CompletePreviewButtons_1.validateQuestionData)({ is_question, questions });
        if (questionError)
            errors.unshift(questionError);
        return errors;
    };
    const generateUpdates = () => {
        return Object.assign(Object.assign({}, (0, CompletePreviewButtons_1.generateRoomData)({ roomData, isEdit, isCommission: true })), (0, CompletePreviewButtons_1.generateQuestionData)({ is_question, questions, delete_questions }));
    };
    const { enqueueSnackbar, closeSnackbar } = (0, notistack_1.useSnackbar)();
    const snackbarOptions = {
        variant: 'warning',
        autoHideDuration: 99999,
        onClick: () => closeSnackbar(),
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const submitCommissionRoomData = () => __awaiter(this, void 0, void 0, function* () {
        setIsSubmitting(true);
        const errorsArr = generateErrors();
        if (errorsArr.length) {
            errorsArr.forEach((errorMsg) => enqueueSnackbar(errorMsg, snackbarOptions));
            setIsSubmitting(false);
        }
        else {
            const updates = generateUpdates();
            yield (0, api_1.patchData)(`/api/v1/store/room/${roomId}`, updates)
                .then(res => {
                if (res.status === 200) {
                    window.onbeforeunload = null;
                    window.location.replace(`/room/commission-view/${roomId}`);
                }
            })
                .catch(() => {
                confirm({
                    description: (0, errors_1.commonErrorMsg)(),
                    cancellationButtonProps: { style: { display: 'none' } },
                }).finally(() => setIsSubmitting(false));
            });
        }
    });
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const isPC = !maxWidth768;
    const isEditPC = isPC && isEdit;
    return ((0, jsx_runtime_1.jsx)(wrapper_component_1.SubmitButtonWrapper, Object.assign({ isSticky: isEdit, isPCView: isPC, isFixedPCView: isEditPC }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: submitCommissionRoomData, disabled: isSubmitting, sx: {
                width: maxWidth768 ? '100%' : 'unset',
                height: '56px',
                minWidth: maxWidth768 ? 'unset' : '183px',
                padding: '12px 36px',
                borderRadius: '12px',
                bgcolor: 'var(--primary-main) !important',
                color: 'var(--white)',
            } }, { children: isSubmitting ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "info", thickness: 8 })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: isEdit ? t('수정 완료') : t('등록 완료') }))) })) })));
}
exports.default = default_1;
